<script>
import { authComputed } from '@state/helpers'
import NavBarRoutes from './nav-bar-routes'
import _ from 'lodash'
// import liveChat from '@components/live-chat'

export default {
  components: { NavBarRoutes },
  data() {
    return {
      persistentNavRoutes: [
        {
          name: 'dispute',
          title: 'Dispute',
        },
        {
          name: 'contact',
          title: 'Contact Us',
        },
      ],
      loggedInNavRoutes: [
        {
          name: 'dashboard',
          title: 'My Reports',
        },
        {
          name: 'logout',
          title: 'Sign Out',
        },
      ],
      loggedOutNavRoutes: [
        {
          name: 'login',
          title: 'Consumer Sign In',
        },
      ],
    }
  },
  computed: {
    ...authComputed,
    navBarMenu() {
      return _.get(this, '$store.state.referrer.referrerData.menu')
    },
    hasCartProduct() {
      return _.get(this, '$store.state.customer.cart')
    },
  },
}
</script>

<template>
  <div class="row" :class="$style.navBar">
    <div class="container d-md-block d-none">
      <div class="row">
        <div class="col-12">
          <ul :class="$style.topNav">
            <!--<li>
              <keep-alive include="liveChat">
                <liveChat :is-link="true" />
              </keep-alive>
            </li>-->
            <li>
              <a
                href="https://www.autocheck.com/members/login.do"
                target="_blank"
                >Dealer Sign In
              </a>
            </li>
            <NavBarRoutes :routes="persistentNavRoutes" />
            <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
            <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
            <!--<li v-if="!hasCartProduct">
              <span>
                <BaseIcon name="shopping-cart" />Secure Checkout (0)
              </span>
            </li>
            <li v-else>
              <BaseLink :to="{ name: 'checkout' }">
                <BaseIcon name="shopping-cart" />Secure Checkout (1)
              </BaseLink>
            </li>-->
          </ul>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-4">
          <BaseLink :to="{ path: '/vehiclehistory/' }">
            <img
              :class="$style.logo"
              class="pb-4"
              src="@assets/images/AutoCheck-by-Experian-Logo.png"
              alt="Logo"
            />
          </BaseLink>
        </div>
        <div class="col">
          <div class="navbar-collapse">
            <ul class="navbar-nav ml-auto" :class="$style.navBarNav">
              <li
                v-for="(subMenu, index) in navBarMenu"
                :key="index"
                class="nav-item dropdown"
              >
                <template v-if="index === 1">
                  <BaseLink
                    v-if="subMenu.route.name"
                    :to="subMenu.route"
                    class="nav-link"
                    style="margin: 0 1rem;"
                    >{{ subMenu.route.title }}</BaseLink
                  >
                  <span v-else class="nav-link">{{ subMenu.route.title }}</span>
                </template>
                <template v-else>
                  <BaseLink
                    v-if="subMenu.route.name"
                    :to="subMenu.route"
                    class="nav-link"
                    style="margin: 0 0;"
                    >{{ subMenu.route.title }}</BaseLink
                  >
                  <span v-else class="nav-link">{{ subMenu.route.title }}</span>
                </template>
                <div class="dropdown-menu">
                  <NavBarRoutes :routes="subMenu.items" />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="container d-md-none d-block">
      <b-navbar
        fixed="top"
        class="row no-gutters"
        type="light"
        variant="light"
        toggleable="md"
        :class="$style.navBarMobile"
      >
        <div class="col-4 col-sm-3">
          <b-navbar-toggle style="height: 40px;" target="nav_dropdown_collapse">
            <BaseIcon name="bars" />
          </b-navbar-toggle>
          <b-collapse id="nav_dropdown_collapse" is-nav>
            <b-navbar-nav>
              <li
                v-for="(subMenu, index) in navBarMenu"
                :key="index"
                class="nav-item dropdown"
              >
                <template v-if="index === 1">
                  <BaseLink
                    v-if="subMenu.route.name"
                    :to="subMenu.route"
                    class="nav-link"
                    style="margin: 0 1rem;"
                    >{{ subMenu.route.title }}</BaseLink
                  >
                  <span v-else class="nav-link">{{ subMenu.route.title }}</span>
                </template>
                <template v-else>
                  <BaseLink
                    v-if="subMenu.route.name"
                    :to="subMenu.route"
                    class="nav-link"
                    style="margin: 0 0;"
                    >{{ subMenu.route.title }}</BaseLink
                  >
                  <span v-else class="nav-link">{{ subMenu.route.title }}</span>
                </template>
                <NavBarRoutes :routes="subMenu.items" />
              </li>
            </b-navbar-nav>
          </b-collapse>
        </div>
        <div class="col-4 col-sm-6">
          <b-navbar-brand :class="$style.mobileLogo">
            <BaseLink :to="{ path: '/vehiclehistory/' }">
              <img
                :class="$style.logo"
                src="@assets/images/logo-autocheck.png"
                alt="Autocheck Logo"
              />
            </BaseLink>
          </b-navbar-brand>
        </div>
        <div class="col-4 col-sm-3 flex-row d-flex" :class="$style.mobileIcons">
          <b-navbar-toggle
            target="user_dropdown_collapse"
            :class="$style.userIcon"
            class="mr-2"
          >
            <BaseIcon name="user" />
          </b-navbar-toggle>
          <b-collapse id="user_dropdown_collapse" class="navbar-right" is-nav>
            <b-navbar-nav>
              <NavBarRoutes :routes="persistentNavRoutes" />
              <NavBarRoutes v-if="loggedIn" :routes="loggedInNavRoutes" />
              <NavBarRoutes v-else :routes="loggedOutNavRoutes" />
            </b-navbar-nav>
          </b-collapse>
          <span
            v-if="!hasCartProduct"
            class="navbar-toggler"
            :class="$style.userIcon"
          >
            <span>
              <BaseIcon name="shopping-cart" />
            </span>
          </span>
          <span v-else :class="$style.userIcon" class="navbar-toggler">
            <BaseLink :to="{ name: 'checkout' }">
              <BaseIcon name="shopping-cart" />
            </BaseLink>
          </span>
        </div>
      </b-navbar>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.navBar {
  position: relative;
  z-index: 1;
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.35);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.35);
}

.mobileIcons {
  justify-content: flex-end;
  padding-right: 30px;
}

.navBarMobile {
  background-color: #fff;
  -webkit-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.35);
  -moz-box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.35);
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.35);
  min-height: 75px;
}

.mobileLogo {
  margin: 0;
}

.userIcon {
  display: flex;
  align-items: center;
  height: 40px;
}

.topNav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 36px;
  padding: 0;
  margin-bottom: 0;
  font-size: 14px;
  text-align: right;
  list-style-type: none;
  > li {
    display: inline-block;
    &:last-child {
      a {
        border-right: none;
      }
    }
    a {
      padding: 0 5px;
      font-size: 14px;
      line-height: 14px;
      color: #2e2e2e !important;
      border-right: 1px solid #000;
      border-radius: 0 !important;
      &:hover {
        text-decoration: underline;
        background-color: #fff;
      }
    }
    span {
      padding: 0 5px;
    }
  }
}

.navBarNav {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 10px;
  > li {
    padding: 0.5rem 0;
    font-size: 16px;
    font-weight: bold;
    color: #004990;
    a {
      &:hover {
        color: #0175de;
      }
    }
    &:hover {
      /* background-clip: padding-box; */

      /* border: 1px solid rgba(0, 0, 0, 0.15); */

      /* border-radius: 0.25rem 0.25rem ; */
      > div {
        position: absolute;
        display: block;
        cursor: pointer;
        border-radius: 0;
        -webkit-box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
        box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
        li {
          a {
            font-weight: normal;
            color: #004990;
          }
        }
      }
    }
    span {
      margin: 0 1rem;
      cursor: pointer;
    }
  }
}

.logo {
  max-width: 212px;
  height: auto;
}
</style>
